import type { ChatDoc } from '@odo/shared-ui';
import apiV2 from '../api/v2';

// Mirror the backend's quick-replies.validator.ts.
export const MAX_QUICK_REPLY_CODE_LENGTH = 60;
export const MAX_QUICK_REPLY_TITLE_LENGTH = 120;
export const MAX_QUICK_REPLY_CATEGORY_LENGTH = 60;
export const MAX_QUICK_REPLY_BODY_DOC_JSON_LENGTH = 20_000;
export const QUICK_REPLY_CODE_PATTERN = /^[A-Z0-9][A-Z0-9-]*$/;

export type QuickReplyChatType = 'external' | 'internal';

export interface ConversationQuickReply {
    id: string;
    code: string;
    title: string;
    category: string;
    chatType: QuickReplyChatType;
    bodyDoc: ChatDoc;
    sortOrder: number;
    isActive: boolean;
    updatedAt: string;
    updatedBy: string | null;
}

export interface QuickReplyListFilter {
    chatType?: QuickReplyChatType;
}

export interface CreateQuickReplyBody {
    code: string;
    title: string;
    category: string;
    chatType: QuickReplyChatType;
    bodyDoc: ChatDoc;
    sortOrder?: number;
}

export type UpdateQuickReplyBody = Partial<
    Omit<CreateQuickReplyBody, 'sortOrder'> & { sortOrder: number; isActive: boolean }
>;

interface Envelope<T> {
    success: boolean;
    data: T;
}

const BASE_PATH = '/conversations/quick-replies';

export async function fetchConversationQuickReplies(
    filter: QuickReplyListFilter
): Promise<ConversationQuickReply[]> {
    const response = await apiV2.get<Envelope<ConversationQuickReply[]>>(BASE_PATH, {
        params: filter
    });
    return response.data.data;
}

export async function createConversationQuickReply(
    body: CreateQuickReplyBody
): Promise<ConversationQuickReply> {
    const response = await apiV2.post<Envelope<ConversationQuickReply>>(BASE_PATH, body);
    return response.data.data;
}

export async function updateConversationQuickReply(
    id: string,
    body: UpdateQuickReplyBody
): Promise<ConversationQuickReply> {
    const response = await apiV2.patch<Envelope<ConversationQuickReply>>(
        `${BASE_PATH}/${id}`,
        body
    );
    return response.data.data;
}
